export class FormaDePagamento {}
